import React from 'react'
import "./Loder.css"
export default function Loder() {
  return (
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  )
}
